import React from 'react';
import styled from 'styled-components';

const Container = ({ className, children }) => (
  <div
    className={`${className} guide-overlay ms-font-xl ms-fontWeight-semibold`}
  >
    {children}
  </div>
);

// const StyledContainer = styled(Container)`
//   background-color: #ffffff;
//   top: 0;
//   bottom: 0;
//   left: 0;
//   right: 0;
//   position: absolute;
//   text-align: center;
//   color: #404041;
//   border-radius: 2px;
// `;

const StyledContainer = styled(Container)`
  background-color: #ffffff;
  text-align: center;
  color: #404041;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const GuideOverlay = ({ label = '', isVisible = true, theme, children }) => {
  return isVisible ? (
    <StyledContainer theme={theme}>{children}</StyledContainer>
  ) : null;
};

export default GuideOverlay;



// WEBPACK FOOTER //
// ./src/app/components/GuideOverlay/index.jsx